module.exports = __webpack_public_path__ + "media/src/images/certificates/generic_sop_sample-ab128c9d415375fea9fb41077e795c22.jpg";